// config.ts
import { Config } from "@adornis/config/config.js";
var config = new Config("mails", {
  SMTP_FROM: {
    client: false,
    env: true,
    name: "SMTP_FROM",
    required: false,
    defaultVal: "Adornis Test Service <test@adornis.de>"
  },
  SMTP_HOST: {
    client: false,
    env: true,
    name: "SMTP_HOST",
    required: false,
    defaultVal: "mail.adornis.de"
  },
  SMTP_USER: {
    client: false,
    env: true,
    name: "SMTP_USER",
    required: false,
    defaultVal: "test@adornis.de"
  },
  SMTP_PASSWORD: {
    client: false,
    env: true,
    name: "SMTP_PASSWORD",
    required: false,
    defaultVal: "dornaill10"
  },
  SMTP_USE_AUTH: {
    client: false,
    env: true,
    name: "SMTP_USE_AUTH",
    required: false,
    defaultVal: true,
    parse(value) {
      return value === "1" || value === "true";
    }
  },
  SMTP_SECURE: {
    client: false,
    env: true,
    name: "SMTP_SECURE",
    required: false,
    defaultVal: false,
    parse(value) {
      return value === "1" || value === "true";
    }
  },
  SMTP_PORT: {
    client: false,
    env: true,
    name: "SMTP_PORT",
    required: false,
    defaultVal: 587,
    parse(value) {
      return parseInt(value);
    }
  }
});
var alternativeConfig = new Config("mails", {
  SMTP_FROM_ALT: {
    client: false,
    env: true,
    name: "SMTP_FROM_ALT",
    required: false,
    defaultVal: "Adornis Test Service Alt <test@adornis.de>"
  },
  SMTP_HOST_ALT: {
    client: false,
    env: true,
    name: "SMTP_HOST_ALT",
    required: false,
    defaultVal: "mail.adornis.de"
  },
  SMTP_USER_ALT: {
    client: false,
    env: true,
    name: "SMTP_USER_ALT",
    required: false,
    defaultVal: "test@adornis.de"
  },
  SMTP_PASSWORD_ALT: {
    client: false,
    env: true,
    name: "SMTP_PASSWORD_ALT",
    required: false,
    defaultVal: "dornaill10"
  },
  SMTP_USE_AUTH_ALT: {
    client: false,
    env: true,
    name: "SMTP_USE_AUTH_ALT",
    required: false,
    defaultVal: true,
    parse(value) {
      return value === "1" || value === "true";
    }
  },
  SMTP_SECURE_ALT: {
    client: false,
    env: true,
    name: "SMTP_SECURE_ALT",
    required: false,
    defaultVal: false,
    parse(value) {
      return value === "1" || value === "true";
    }
  },
  SMTP_PORT_ALT: {
    client: false,
    env: true,
    name: "SMTP_PORT_ALT",
    required: false,
    defaultVal: 587,
    parse(value) {
      return parseInt(value);
    }
  }
});
export {
  alternativeConfig,
  config
};
